/*
 *   File : accordion.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Accordion
 *   Integrations : null
 *   Version : 1.0.0
 *   Created : 09-12-2021
 */

/*import package*/
import React, { useEffect, useRef, useState } from 'react';

/*import components*/


/*import style*/
import styles from '../../styles/components/accordionUserInvestment.module.scss';

/*import assets*/
// import Icon from '../../assets/images/dataFormating/Icon.svg';
import { InvestmentBreakdownTooltip } from '../badge';
import { PrimaryBtn, SecondaryBtn } from '../cta';
import { Modal } from 'bootstrap';
import MiniRebalance from '../modal/mini-rebalance';
import { SIPMiniRebalance } from '../modal';

/* Format helpers for the goal card. The goal-summary API returns these
 * fields as raw numbers (e.g. 316078.74, 35.09) while the top user summary
 * card uses pre-formatted strings — so we add ₹/% and Indian grouping here.
 * If the value already comes in as a string with the symbol, we pass it
 * through unchanged so we never double-prefix. */
const _formatRupee = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'string' && value.includes('₹')) return value;
    const num = Number(value);
    if (!Number.isFinite(num)) return value;
    const sign = num < 0 ? '-' : '';
    return `${sign}₹${Math.abs(num).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
};

const _formatPercent = (value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (typeof value === 'string' && value.trim().endsWith('%')) return value;
    const num = Number(value);
    if (!Number.isFinite(num)) return value;
    return `${num}%`;
};

export default function AccordionUserInvestment(props) {
    const [id, setId] = useState(null);
    const wrapperRef = useRef(null);
    const accordionRefs = useRef([]);
    //eslint-disable-next-line
    const [tooltip, setTooltip] = useState(false);
    const [rebalanceData, setRebalanceData] = useState(null);
    const [sipRebalanceData, setSipRebalanceData] = useState(null);

    console.log('sipRebalanceData', sipRebalanceData);


    // /* ----- closing tooltip on mouse click in any other position of screen ----*/
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.addEventListener('mouseup', closeMenu);
        return () => {
            document.removeEventListener('mouseup', closeMenu);
        };
    }, []);

    useEffect(() => {
        if (rebalanceData !== null) {
            const modal = new Modal(document.getElementById("mini-rebalance"));
            modal.show();
        }
    }, [rebalanceData]);

    useEffect(() => {
        if (sipRebalanceData !== null) {
            const modal = new Modal(document.getElementById("sip-mini-rebalance"));
            modal.show();
        }
    }, [sipRebalanceData]);

    const closeMenu = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setTooltip(null)
        }
    }

    function _handleMiniRebalance(data) {
        setRebalanceData(data)
    };
    function _handleSipRebalance(data) {
        setSipRebalanceData(data)
    };

    function _hasPositiveCurrentValue(value) {
        const numericValue = Number(String(value ?? 0).replace(/[^0-9.-]/g, ''));
        return !Number.isNaN(numericValue) && numericValue > 0;
    }



    return (
        <div className={`${styles.e_user_accordion} e-allcation-accordion`}>
            <div className="accordion" id="accordionDescription">
                <div className="row mx-0">
                    {
                        props.summaryData.map((item, key) => {
                            return (
                                <div ref={(el) => (accordionRefs.current[key] = el)}
                                    className={`${styles.e_accordion_sec} col-lg-12`}>
                                    <div className={`${styles.e_accordion_item} accordion-item`}>
                                        <h2 className={`${styles.e_accordion_header} accordion-header`} id={"collapseDescription" + key} >
                                            <button className={`${styles.e_accordion_button}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${key}`} aria-expanded="false" aria-controls={`collapse${key}`} >
                                                <div className="row" onClick={() => {
                                                    setId(key + 1);

                                                    setTimeout(() => {
                                                        accordionRefs.current[key]?.scrollIntoView({
                                                            behavior: "smooth",
                                                            block: "start"
                                                        });
                                                    }, 200);
                                                }}>
                                                    {
                                                        (key + 1) !== id ?
                                                            <div className="row" >
                                                                <div className="col-lg-10" >
                                                                    <span className={`${styles.e_accordion_title}`}>{item.name}</span>

                                                                </div>
                                                                <div className="col-lg-2" >
                                                                    <span className={`${styles.e_accordion_icon}`} ></span>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                <div className="row" onClick={() => {
                                                    setId(null);
                                                }}>
                                                    {
                                                        (key + 1) === id ?
                                                            <div className="row" >
                                                                <div className="col-lg-10" >
                                                                    <span className={`${styles.e_accordion_title}`}>{item.name}</span>

                                                                </div>
                                                                <div className="col-lg-2" >
                                                                    <span className={`${styles.e_accordion_icon_minus}`} ></span>
                                                                </div>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </button>
                                        </h2>
                                        {
                                            (key + 1) === id ?
                                                <div  >
                                                    <div className={`${styles.e_accordion_body} accordion-body `}>
                                                        <div className={`${styles.e_accordion_wrapper} `}>

                                                            <div className="row w-100">
                                                                {/* Investments */}
                                                                <div className="col-lg-3 col-md-6 mb-3">
                                                                    <div className={`${styles.e_summary_box} h-100 position-relative`}>
                                                                        <h5 className={`${styles.e_summary_title} position-relative`}>
                                                                            Investments
                                                                            <img src={require("../../assets/images/dataFormating/Icon.png").default}
                                                                                alt="Icon"
                                                                                className='ms-2'
                                                                                style={{ cursor: "pointer" }}
                                                                                onMouseEnter={() => setTooltip(key)}
                                                                                onMouseLeave={() => setTooltip(null)} />
                                                                        </h5>
                                                                        {
                                                                            tooltip === key ?
                                                                                <InvestmentBreakdownTooltip
                                                                                    className="e-current-tooltip mt-3"
                                                                                    data={{
                                                                                        invested_amount: item.invested_amount,
                                                                                        total_redemption: item.total_redemptions,
                                                                                        redemption_from_rebalance: item.total_redemption_from_rebalance,
                                                                                        normal_redemption: item.total_normal_redemption,
                                                                                    }} />
                                                                                :
                                                                                null
                                                                        }
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Current</span>
                                                                            <span style={{ color: "green" }} className={`${styles.e_summary_value}`}>{item.current_value}</span>
                                                                        </div>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Invested</span>
                                                                            <span className={`${styles.e_summary_value}`}>{item.invested_amount}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Profit/Loss */}
                                                                <div className="col-lg-3 col-md-6 mb-3">
                                                                    <div className={`${styles.e_summary_box} h-100`}>
                                                                        <h5 className={`${styles.e_summary_title}`}>Profit/Loss</h5>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Unrealized</span>
                                                                            <span className={`${styles.e_summary_value}`}>{_formatRupee(item.unrealized_gain)}</span>
                                                                        </div>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Realized</span>
                                                                            <span className={`${styles.e_summary_value}`}>{_formatRupee(item.realised_gain)}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Profit/Loss % */}
                                                                <div className="col-lg-3 col-md-6 mb-3">
                                                                    <div className={`${styles.e_summary_box} h-100`}>
                                                                        <h5 className={`${styles.e_summary_title}`}>Profit/Loss %</h5>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>XIRR</span>
                                                                            <span className={`${styles.e_summary_value}`}>{_formatPercent(item.customer_xirr_text ?? item.customer_xirr)}</span>
                                                                        </div>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Absolute</span>
                                                                            <span className={`${styles.e_summary_value}`}>{_formatPercent(item.returns)}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {/* Amount In Processing */}
                                                                <div className="col-lg-3 col-md-6 mb-3">
                                                                    <div className={`${styles.e_summary_box} h-100`}>
                                                                        <h5 className={`${styles.e_summary_title}`}>Amount In Processing</h5>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Lumpsum</span>
                                                                            <span className={`${styles.e_summary_value}`}>{item.lumpsum_processing_amount_text ?? '-'}</span>
                                                                        </div>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>SIP</span>
                                                                            <span className={`${styles.e_summary_value}`}>{item.sip_processing_amount_text ?? '-'}</span>
                                                                        </div>
                                                                        <div className={`${styles.e_summary_row} d-flex justify-content-between align-items-center`}>
                                                                            <span className={`${styles.e_summary_label}`}>Withdrawal</span>
                                                                            <span className={`${styles.e_summary_value}`}>{item.withdrawal_processing_amount_text ?? '-'}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                item && item.funds && item.funds.length > 0 ?
                                                                    <>
                                                                        <div className='row pt-4'>
                                                                            <div className="col-lg-12" >
                                                                                <span className={`${styles.e_accordion_sub_title}`}>Funds and investments</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row pt-2'>
                                                                            <div className='col-lg-12'>
                                                                                <div className={`${styles.e_investment_wrapper} `}>
                                                                                    <div className='row'>
                                                                                        <div className='col-lg-6'>
                                                                                            <h6>Invested Funds</h6>
                                                                                        </div>
                                                                                        <div className='col-lg-2'>
                                                                                            <h6>Weightage</h6>
                                                                                        </div>
                                                                                        <div className='col-lg-4'>
                                                                                            <h6>Amount</h6>
                                                                                        </div>
                                                                                    </div>
                                                                                    {

                                                                                        item.funds.map((fundData) => {
                                                                                            return (
                                                                                                <div className='row'>
                                                                                                    <div className='col-lg-6'>
                                                                                                        <p className='pt-3'>{fundData.scheme_name}</p>
                                                                                                    </div>
                                                                                                    <div className='col-lg-2'>
                                                                                                        <p className='pt-3'>{fundData.allocation !== null ? fundData.allocation : "0"}%</p>
                                                                                                    </div>
                                                                                                    <div className='col-lg-4'>
                                                                                                        <p className='pt-3'>{fundData.invested_amount ? `₹ ${(fundData.invested_amount)}` : "₹ 0"}</p>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })

                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                            <div className='col-lg-4 pt-3 offset-lg-8 d-flex align-items-center justify-content-center gap-3'>
                                                                                {item.sip_data?.length !== 0 &&
                                                                                    <SecondaryBtn name="SIP Mini Rebalance"
                                                                                        className='padding-10px-tb'
                                                                                        handleClick={() => _handleSipRebalance(item)} />
                                                                                }


                                                                                {
                                                                                    _hasPositiveCurrentValue(item.current_value) &&
                                                                                    <PrimaryBtn name="Mini Rebalance"
                                                                                        handleClick={() => _handleMiniRebalance(item)} />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>


                                                    </div>
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            {
                rebalanceData !== null && <MiniRebalance updateOrder={props.updateOrder}
                    id={props.id}
                    handleCloseModal={() => setRebalanceData(null)}
                    data={rebalanceData} />
            }
            {
                sipRebalanceData !== null && <SIPMiniRebalance updateOrder={props.updateOrder}
                    id={props.id}
                    handleCloseModal={() => setSipRebalanceData(null)}
                    data={sipRebalanceData} />
            }
        </div>
    );
}


